/* Paintly Kits AI Studio, homepage section (A7, approved 4 Oct 2026). Built by build_theme.py from the prototype:
   data.js, engine.js, end.js, gal.js, a3.js, a5.js, then the theme boot. */
/* Paintly Kits AI Studio section, round 2. Facts read from the live store on 4 Oct 2026 (prototype data only).
   AI kits from $26.95 (Design Your Own Paint by Number with AI). The AI pages give 2 designs each go and 3 free tries
   a day (live generator copy). Editing works today: every design page links to the AI Studio with ?remix=<handle>. */
window.AIS = {
  store: '',
  gen: '/products/custom-ai-paint-by-numbers-kit',
  pet: '/products/custom-ai-pet-portrait-paint-by-numbers-kit',
  portrait: '/products/custom-ai-portrait-paint-by-numbers-kit',
  studio: '/pages/ai-studio',
  browse: '/collections/paint-by-number-collection',
  from: '$26.95',
  /* owner's picks: the descriptions are what a customer might type; the designs are ours */
  describe: [
    { k: 'cat', title: 'Cabernet Cat', handle: 'cabernet-cat', prompt: 'A black cat lounging next to a glass of red wine, by candlelight' },
    { k: 'nola', title: 'New Orleans Rainy Cafe', handle: 'new-orleans-rainy-cafe-watercolor-paint-by-numbers', prompt: 'A rainy evening at a New Orleans cafe, in watercolor' },
    { k: 'iris', title: 'Iris Bloom Symphony', handle: 'iris-bloom-symphony', prompt: 'A burst of irises in every color' },
    { k: 'ocean', title: 'Ocean Wave Dress', handle: 'woman-ocean-wave-dress-paint-by-numbers', prompt: 'A woman walking into the sea, her dress turning into ocean waves' }
  ],
  /* the edits were made with Nano Banana 2, the same family of model the AI Studio uses (nano-banana-2) */
  change: [
    { k: 'queen', title: 'Queen of the Rolling Tempest', handle: 'queen-of-the-rolling-tempest-paint-by-numbers', ask: 'Make her Caucasian with blonde wavy hair' },
    { k: 'turtle', title: 'Sea Turtle Among Moon Jellies', handle: 'sea-turtle-among-moon-jellies-paint-by-numbers', ask: 'Make all the jellyfish colorful' },
    { k: 'terrace', title: 'Whitewashed Terrace', handle: 'whitewashed-terrace-by-moonlight-paint-by-numbers', ask: 'Make it a glamorous Paris night' }
  ]
};
/* theme: the section passes the AI kit's link and from price, and the image addresses (window.AIS_CFG) */
(function (C) { if (!C) return; if (C.gen) AIS.gen = C.gen; if (C.from) AIS.from = C.from; })(window.AIS_CFG);
AIS.url = function (p) { return AIS.store + p; };
AIS.remix = function (h) { return AIS.store + AIS.gen + '?remix=' + h; };
/* the single-file versions map these paths to inline data */
AIS.a = function (p) {
  var C = window.AIS_CFG; if (!C) return (window.AIS_ASSETS && window.AIS_ASSETS[p]) || p;
  var m = /^assets\/(v[pd])-(\d{3})\.webp$/.exec(p);  /* film frames: same address as frame 001, other number */
  if (m) return C[m[1]].replace('ais-' + m[1] + '-001.webp', 'ais-' + m[1] + '-' + m[2] + '.webp');
  return C.img[p.replace(/^assets\//, '').replace(/\.webp$/, '')] || p;
};
AIS.img = function (k, size) { return AIS.a('assets/' + k + (size === 'm' ? '-m' : size === 't' ? '-t' : '') + '.webp'); };
AIS.icon = {
  spark: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5c.5 4.6 2.4 6.9 7 7.5-4.6.6-6.5 2.9-7 7.5-.5-4.6-2.4-6.9-7-7.5 4.6-.6 6.5-2.9 7-7.5Z"/><path d="M19 15.5c.25 2 1.05 2.8 3 3-1.95.25-2.75 1-3 3-.25-2-1.05-2.75-3-3 1.95-.2 2.75-1 3-3Z"/></svg>',
  arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
  pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
  play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.4-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z"/></svg>',
  drag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 7-5 5 5 5"/><path d="m15 7 5 5-5 5"/></svg>',
  pen: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4Z"/><path d="m13.5 6.5 4 4"/></svg>',
  wand: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 20 11-11"/><path d="m13 7 4 4"/><path d="M18 3v3M16.5 4.5h3M20 9v2M19 10h2M9 3v2M8 4h2"/></svg>',
  photo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="m21 16-5-5-8 8"/></svg>'
};

/* Shared demo engine: a typed prompt, a painting that develops, a before/after wipe, and a player that runs one
   example after another while the demo is on screen, with chips to jump and a pause button. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Player(o) {
    /* o: { root, n, chips, pause, run(i, t) -> Promise, show(i) (instant final state), hold, threshold } */
    var self = this; this.o = o; this.i = 0; this.tok = 0; this.paused = reduce; this.vis = false; this.started = false; this.waiting = false;
    this.t = {
      live: function (k) { return k === self.tok; },
      wait: function (ms, k) { return new Promise(function (res, rej) { setTimeout(function () { k === self.tok ? res() : rej('stop'); }, ms); }); },
      type: function (el, text, k, cps) {
        el.classList.add('ais-type', 'on'); el.textContent = '';
        var n = 0, step = 1000 / (cps || 34);
        return new Promise(function (res, rej) {
          (function tick() {
            if (k !== self.tok) return rej('stop');
            el.textContent = text.slice(0, ++n);
            if (n >= text.length) { setTimeout(function () { el.classList.remove('on'); res(); }, 250); return; }
            setTimeout(tick, step * (text[n - 1] === ',' ? 5 : text[n - 1] === ' ' ? 1.2 : 1));
          })();
        });
      }
    };
    if (o.chips) Array.prototype.forEach.call(o.chips, function (c, j) { c.addEventListener('click', function () { self.go(j, true); }); });
    if (o.pause) o.pause.addEventListener('click', function () { self.setPaused(!self.paused); });
    this.setPaused(this.paused, true);
    if (reduce) { this.mark(o.start || 0); o.show(o.start || 0); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        self.vis = e.isIntersecting;
        if (self.vis && !self.started && !o.manual) { self.started = true; self.go(o.start || 0); }
        else if (self.vis && self.waiting && !self.paused) self.go((self.i + 1) % o.n);
      });
    }, { threshold: o.threshold || 0.35 });
    io.observe(o.watch || o.root);
  }
  Player.prototype.start = function (i) { this.started = true; if (reduce) { this.mark(i); this.o.show(i); return; } this.go(i); };
  Player.prototype.stop = function () { this.tok++; this.waiting = false; };
  Player.prototype.mark = function (i) {
    if (this.o.chips) Array.prototype.forEach.call(this.o.chips, function (c, j) { c.setAttribute('aria-pressed', String(i === j)); });
  };
  Player.prototype.setPaused = function (p, quiet) {
    this.paused = p; var b = this.o.pause;
    if (b) { b.innerHTML = p ? AIS.icon.play : AIS.icon.pause; b.setAttribute('aria-label', p ? 'Play the examples' : 'Pause the examples'); }
    if (!p && !quiet && this.waiting) this.go((this.i + 1) % this.o.n);
  };
  Player.prototype.go = function (i, user) {
    var self = this, k = ++this.tok; this.i = i; this.waiting = false; this.mark(i);
    if (reduce) { this.o.show(i); return; }
    this.o.run(i, this.t, k).then(function () { return self.t.wait(self.o.hold || 3400, k); }).then(function () {
      if (k !== self.tok) return;
      if (self.paused || !self.vis) { self.waiting = true; return; }
      self.go((i + 1) % self.o.n);
    }).catch(function () {});
  };

  /* before / after: the edited picture sits on top and is uncovered from the left */
  function Compare(el, label) {
    var self = this; this.el = el; this.x = 100;
    var r = document.createElement('input'); r.type = 'range'; r.min = 0; r.max = 100; r.value = 100; r.className = 'ais-focus';
    r.setAttribute('aria-label', label || 'Slide to compare before and after');
    r.addEventListener('input', function () { self.stop(); self.set(+r.value); el.classList.add('ready'); if (self.onUser) self.onUser(); });
    el.appendChild(r); this.r = r; this.raf = 0;
  }
  Compare.prototype.set = function (x) { this.x = x; this.el.style.setProperty('--x', x + '%'); this.r.value = x; };
  Compare.prototype.stop = function () { if (this.raf) cancelAnimationFrame(this.raf); this.raf = 0; };
  Compare.prototype.sweep = function (to, ms) {
    var self = this, from = this.x, t0 = performance.now(); this.stop();
    return new Promise(function (res) {
      (function f(t) {
        var p = Math.min(1, (t - t0) / ms), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        self.set(from + (to - from) * e);
        if (p < 1) self.raf = requestAnimationFrame(f); else { self.raf = 0; res(); }
      })(t0);
    });
  };

  /* load an image and wait for it */
  function load(img, src) {
    return new Promise(function (res) { if (img.getAttribute('src') === src && img.complete) return res(); img.onload = img.onerror = function () { res(); }; img.src = src; });
  }
  window.AISE = { Player: Player, Compare: Compare, load: load, reduce: reduce };
})();

/* Round 2 additions: scroll-linked scenes, scroll typing, play-once-on-view, and the brush of light. */
(function () {
  var E = window.AISE;
  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  E.clamp = clamp;
  E.seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  E.ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  E.inout = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  E.lerp = function (a, b, t) { return a + (b - a) * t; };
  /* progress through a tall wrapper whose child is sticky: 0 when the wrapper top is `pre` screens below the top
     of the screen, 1 when the sticky frame is about to scroll away */
  E.pin = function (wrap, fn, pre) {
    pre = pre || 0;
    if (E.reduce) { wrap.classList.add('ais-nopin'); fn(1, true); return function () {}; }
    var ticking = false;
    function m() { ticking = false; var r = wrap.getBoundingClientRect(), vh = window.innerHeight; fn(clamp((vh * pre - r.top) / (vh * pre + r.height - vh))); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(m); } }, { passive: true });
    window.addEventListener('resize', m); m();
    return m;
  };
  /* type a line in proportion to scroll */
  E.typeTo = function (el, text, q) {
    var n = Math.round(text.length * clamp(q));
    if (el._n !== n) { el._n = n; el.textContent = text.slice(0, n); }
    el.classList.add('ais-type'); el.classList.toggle('on', q > 0 && q < 1);
  };
  /* run fn the first time el is well on screen */
  E.onView = function (el, fn, th) {
    if (E.reduce) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: th || .45 });
    io.observe(el);
  };
  /* animate a value 0..1 over ms, returns a promise; k/T from a Player keep it cancellable */
  E.tween = function (ms, fn, T, k) {
    var t0 = performance.now();
    return new Promise(function (res, rej) {
      (function f(t) {
        if (T && !T.live(k)) return rej('stop');
        var p = Math.min(1, (t - t0) / ms); fn(p);
        if (p < 1) requestAnimationFrame(f); else res();
      })(t0);
    });
  };

  /* The brush of light: an image is painted in by wide brush strokes (an SVG mask), with a glowing AI Studio
     colored tip on the stroke being painted. set(q) for 0..1. The canvas is 300 x 400 (3:4). */
  var uid = 0;
  var PASSES = [];
  (function () {
    var ys = [26, 88, 150, 212, 274, 336, 392];
    ys.forEach(function (y, i) {
      var l = i % 2 === 0, a = l ? -30 : 330, b = l ? 330 : -30, w = (i % 3) * 7 - 7;
      PASSES.push('M' + a + ' ' + (y + 10) + ' C ' + (l ? 70 : 230) + ' ' + (y - 22 + w) + ', ' + (l ? 210 : 90) + ' ' + (y + 24 - w) + ', ' + b + ' ' + (y - 8));
    });
  })();
  E.brushSVG = function (opt) {
    /* opt: { top: image painted in, under: image beneath (outline canvas or the before picture), alt } */
    var id = 'aisb' + (++uid), strokes = '', tips = '';
    PASSES.forEach(function (d, i) {
      strokes += '<path class="bm" data-i="' + i + '" d="' + d + '" stroke-width="74"/>' +
        '<path class="bb" data-i="' + i + '" data-lag=".06" d="' + d + '" stroke-width="22" transform="translate(0 -33)"/>' +
        '<path class="bb" data-i="' + i + '" data-lag=".12" d="' + d + '" stroke-width="18" transform="translate(0 34)"/>' +
        '<path class="bb" data-i="' + i + '" data-lag=".03" d="' + d + '" stroke-width="10" transform="translate(0 -46)"/>';
      tips += '<path class="bt" data-i="' + i + '" d="' + d + '"/>';
    });
    return '<svg class="ais-brush" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid slice" role="img" aria-label="' + (opt.alt || '') + '">' +
      '<defs><filter id="' + id + 'r" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency=".06" numOctaves="3" seed="' + uid + '"/><feDisplacementMap in="SourceGraphic" scale="24" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<filter id="' + id + 'g" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="9"/></filter>' +
      '<filter id="' + id + 'w" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1.6"/></filter>' +
      '<linearGradient id="' + id + 's" x1="0" x2="1"><stop offset="0" stop-color="#C5FF89"/><stop offset=".25" stop-color="#8AD0FF"/><stop offset=".5" stop-color="#B79CFF"/><stop offset=".75" stop-color="#FF9EC4"/><stop offset="1" stop-color="#FFD37A"/></linearGradient>' +
      '<mask id="' + id + 'm" maskUnits="userSpaceOnUse" x="0" y="0" width="300" height="400"><rect width="300" height="400" fill="#000"/><g filter="url(#' + id + 'r)" fill="none" stroke="#fff" stroke-linecap="round">' + strokes + '</g><rect class="bf" width="300" height="400" fill="#fff" opacity="0"/></mask></defs>' +
      '<image class="under" href="' + (opt.under || '') + '" width="300" height="400" preserveAspectRatio="xMidYMid slice"/>' +
      '<image class="top" href="' + (opt.top || '') + '" width="300" height="400" preserveAspectRatio="xMidYMid slice" mask="url(#' + id + 'm)"/>' +
      '<g class="tips" fill="none" stroke="url(#' + id + 's)" stroke-linecap="round" filter="url(#' + id + 'g)">' + tips + '</g>' +
      '<g class="tips2" fill="none" stroke="#fff" stroke-linecap="round" opacity=".85" filter="url(#' + id + 'w)">' + tips + '</g></svg>';
  };
  function Brush(svg) {
    this.svg = svg; this.q = -1;
    this.m = Array.prototype.map.call(svg.querySelectorAll('.bm,.bb'), function (p) { var L = p.getTotalLength(); p.style.strokeDasharray = L + ' ' + (L + 10); return { p: p, L: L, i: +p.getAttribute('data-i'), lag: +(p.getAttribute('data-lag') || 0) }; });
    this.t = Array.prototype.map.call(svg.querySelectorAll('.tips .bt'), function (p) { var L = p.getTotalLength(); return { p: p, L: L, i: +p.getAttribute('data-i') }; });
    this.t2 = Array.prototype.map.call(svg.querySelectorAll('.tips2 .bt'), function (p) { var L = p.getTotalLength(); return { p: p, L: L, i: +p.getAttribute('data-i') }; });
    this.fill = svg.querySelector('.bf');
    this.set(0);
  }
  Brush.prototype.set = function (q) {
    q = clamp(q); if (q === this.q) return; this.q = q;
    var N = PASSES.length, x = q * (N + .4);
    this.m.forEach(function (s) { var l = clamp(x - s.i - s.lag); s.p.style.strokeDashoffset = (s.L * (1 - l)).toFixed(1); s.p.style.visibility = l > 0 ? 'visible' : 'hidden'; });
    function tip(s, seg, w) {
      var l = clamp(x - s.i), on = l > 0 && l < 1;
      s.p.style.opacity = on ? 1 : 0;
      if (on) { s.p.style.strokeDasharray = seg + ' ' + (s.L + 400); s.p.style.strokeDashoffset = (-(s.L * l - seg)).toFixed(1); s.p.style.strokeWidth = w; }
    }
    this.t.forEach(function (s) { tip(s, 150, 58); });
    this.t2.forEach(function (s) { tip(s, 26, 5); });
    this.fill.setAttribute('opacity', clamp((q - .93) / .07).toFixed(3));
  };
  Brush.prototype.images = function (top, under) {
    if (top != null) this.svg.querySelector('image.top').setAttribute('href', top);
    if (under != null) this.svg.querySelector('image.under').setAttribute('href', under);
  };
  E.Brush = Brush;
})();

/* Round 2 endings. Put <div class="aie" data-end="e1|e2|e3" [data-light] [data-hz]></div> where the ending goes;
   AIS_END.boot() fills it in, sets the real links and starts the typing in e3. */
(function () {
  var E = window.AISE;
  var IDEAS = [
    'My dog dressed as a sea captain, in oil paint',
    'Our first apartment on a snowy night',
    'A fox reading by the fire in a cozy library',
    "Grandma's garden in full bloom, in watercolor"
  ];
  function photoChips() {
    return '<p class="aie-photo"><span>Starting from a photo?</span>' +
      '<a class="aie-chip ais-focus js-pet" href="#"><img src="' + AIS.a('assets/pet-card.webp') + '" alt="">Pet portrait</a>' +
      '<a class="aie-chip ais-focus js-por" href="#"><img src="' + AIS.a('assets/portrait-card.webp') + '" alt="">Portrait</a></p>';
  }
  var T = {
    e1: function () {
      return '<h3 class="aie-h">Your idea.<span>Your kit.</span></h3>' +
        '<p class="aie-sub">Describe a painting, or change one of ours. Then it becomes your own paint by numbers kit.</p>' +
        '<dl class="aie-spec">' +
        '<div><dt>Each go</dt><dd><b>2</b><small>designs to pick from</small></dd></div>' +
        '<div><dt>Every day</dt><dd><b>3</b><small>free tries</small></dd></div>' +
        '<div><dt>Kits from</dt><dd><b>' + AIS.from + '</b><small>everything you need</small></dd></div></dl>' +
        '<a class="ais-btn aie-go ais-focus js-gen" href="#">Start creating <span class="js-arrow"></span></a>' +
        '<p class="aie-or"><span>Or start from a photo</span></p>' +
        '<div class="aie-cards">' +
        '<a class="aie-card ais-focus js-pet" href="#"><img src="' + AIS.a('assets/pet-card.webp') + '" alt=""><span><b>Pet portrait</b><small>Your pet, painted from a photo</small></span><i class="js-arrow"></i></a>' +
        '<a class="aie-card ais-focus js-por" href="#"><img src="' + AIS.a('assets/portrait-card.webp') + '" alt=""><span><b>Portrait</b><small>Someone you love, from a photo</small></span><i class="js-arrow"></i></a></div>';
    },
    e2: function (nophoto) {
      return '<h3 class="aie-h">Your idea.<span>Your kit.</span></h3>' +
        '<ol class="aie-steps">' +
        '<li><span class="n">1</span><b>Say it</b><p>Describe a painting, or pick one of our designs and say what to change.</p></li>' +
        '<li><span class="n">2</span><b>Pick your favorite</b><p>You get <strong>2 designs each go</strong>, and <strong>3 free tries a day</strong>.</p></li>' +
        '<li><span class="n">3</span><b>Paint it</b><p>It becomes your own paint by numbers kit. <strong>Kits from ' + AIS.from + '.</strong></p></li></ol>' +
        '<div class="aie-row"><a class="ais-btn aie-go ais-focus js-gen" href="#">Start creating <span class="js-arrow"></span></a>' + (nophoto ? '' : photoChips()) + '</div>';
    },
    e3: function () {
      return '<h3 class="aie-h">What will<span>you paint?</span></h3>' +
        '<a class="aie-bar ais-focus js-gen" href="#" aria-label="Start creating in the AI Studio"><span class="bg"></span>' +
        '<span class="aie-field"><i class="js-spark"></i><span class="t" aria-hidden="true">' + IDEAS[0] + '</span></span>' +
        '<span class="ais-btn aie-go">Start creating <span class="js-arrow"></span></span></a>' +
        '<ul class="aie-facts"><li><b>2</b><span>designs each go</span></li><li><b>3</b><span>free tries a day</span></li><li class="pr"><span class="l1">Kits from</span><b>' + AIS.from + '</b><span class="l2">starting price</span></li></ul>' + photoChips();
    }
  };
  function typing(root) {
    var t = root.querySelector('.aie-field .t'); if (!t || E.reduce) return;
    var i = 0, vis = false, run = false;
    function loop() {
      if (!vis) { run = false; return; }
      run = true; var s = IDEAS[i % IDEAS.length], n = 0;
      t.classList.add('ais-type', 'on');
      (function del() {
        if (t.textContent.length) { t.textContent = t.textContent.slice(0, -1); return setTimeout(del, 18); }
        (function add() {
          t.textContent = s.slice(0, ++n);
          if (n < s.length) return setTimeout(add, s[n - 1] === ' ' ? 70 : 46);
          i++; setTimeout(loop, 2600);
        })();
      })();
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { vis = e.isIntersecting; if (vis && !run) setTimeout(loop, 900); }); }, { threshold: .5 }).observe(root.querySelector('.aie-bar'));
  }
  function boot(scope) {
    (scope || document).querySelectorAll('.aie[data-end]').forEach(function (el) {
      if (el.hasAttribute('data-ais-done')) return; el.setAttribute('data-ais-done', '');
      var k = el.getAttribute('data-end');
      el.classList.add(k); if (el.hasAttribute('data-light')) el.classList.add('light');
      var hz = el.hasAttribute('data-hz');
      el.innerHTML = '<div class="aie-in' + (hz ? ' hz' : '') + '">' + T[k](el.hasAttribute('data-nophoto')) + '</div>' + (hz ? '<div class="aie-hz" aria-hidden="true"></div>' : '');
      el.querySelectorAll('.js-gen').forEach(function (a) { a.href = AIS.url(AIS.gen); });
      el.querySelectorAll('.js-pet').forEach(function (a) { a.href = AIS.url(AIS.pet); });
      el.querySelectorAll('.js-por').forEach(function (a) { a.href = AIS.url(AIS.portrait); });
      el.querySelectorAll('.js-arrow').forEach(function (s) { s.innerHTML = AIS.icon.arrow; });
      el.querySelectorAll('.js-spark').forEach(function (s) { s.innerHTML = AIS.icon.spark; });
      if (el.hasAttribute('data-nophoto')) el.querySelectorAll('.aie-photo,.aie-or,.aie-cards').forEach(function (n) { n.remove(); });
      if (k === 'e3') typing(el);
    });
  }
  window.AIS_END = { boot: boot };
})();

/* Daybreak round: the wall-style galleries as a shared part.
   AIS_GAL.html('d'|'c', {light}) gives the markup for one act; AIS_GAL.create(actEl) wires it.
   Phones (the row scrolls sideways): the cards move on by themselves. Each card types its request, then the painting
   develops (Describe) or the change wipes across (Change), then the row slides to the next card and loops. Dots show
   where you are and jump; pause stops it; swiping works too and the row carries on from the card you landed on.
   Computers (all cards side by side): both rows play their cards one by one like on phones (the playing card glows,
   then the next, and it loops); hovering over or tabbing into the cards pauses it, and dragging a before/after line
   stops it. */
(function () {
  var E = window.AISE;
  function html(kind, o) {
    o = o || {};
    var d = kind === 'd';
    var where = d ? '' : whereHtml();  /* placed after the cards: see the examples, then where to do it yourself */
    return '<div class="gl-act gl-' + kind + (o.light ? ' light' : '') + '">' +
      '<div class="gl-head"><p class="gl-num">' + (d ? '01' : '02') + '</p><h3>' + (d ? 'Describe <em>it.</em>' : 'Change <em>anything.</em>') + '</h3>' +
      '<p class="lead">' + (d ? 'Type any idea in your own words. The AI Studio turns it into a paint by numbers design. <b>You get 2 designs each go.</b>'
                              : 'Pick one of our designs and <b>just say what to change.</b> Drag the line to compare.') + '</p></div>' +
      '<div class="gl-row"></div>' +
      '<div class="gl-nav"><div class="gl-dots" role="group" aria-label="Examples"></div><button class="ais-pause ais-focus"></button></div>' + where + '</div>';
  }
  /* text first, then the screenshot of a live design page (on a computer the screenshot moves to the left column) */
  function whereHtml(stack) {
    return '<div class="gl-where' + (stack ? ' stack' : '') + '">' +
      '<div class="tx"><p class="k">Where to find it</p><h4>On every design page</h4>' +
      '<p>Open any of our designs and look right under the <b>Add to cart</b> button. Tap the card and say what you would like to change.</p></div>' +
      '<div class="shot"><img src="' + AIS.a('assets/where-live.webp') + '" alt="Part of a design page on paintlykits.com: the Add to cart button, Buy it now, and right under them the card that says Want this design a little different?" loading="lazy"></div></div>';
  }
  function create(act) {
    var kind = act.classList.contains('gl-d') ? 'd' : 'c', L = kind === 'd' ? AIS.describe : AIS.change;
    var row = act.querySelector('.gl-row'), dots = act.querySelector('.gl-dots');
    row.innerHTML = L.map(function (x) {
      if (kind === 'd') return '<article class="gl-card"><p class="gl-q"><small>Your idea</small><span class="t"></span></p>' +
        '<div class="ais-frame dark"><img class="dev" src="' + AIS.img(x.k, 'm') + '" alt="Example design: ' + x.title + '"><div class="ph">' + AIS.icon.spark + '</div><div class="ais-shimmer"></div></div>' +
        '<p class="gl-foot"><span>' + x.title + '</span><a class="ais-focus" href="' + AIS.url('/products/' + x.handle) + '">See design</a></p></article>';
      return '<article class="gl-card"><p class="gl-q"><small>Your change</small><span class="t"></span></p>' +
        '<div class="ais-cmp"><img class="bf" src="' + AIS.img(x.k, 'm') + '" alt="' + x.title + ', before"><img class="af" src="' + AIS.img(x.k + '-edit', 'm') + '" alt="' + x.title + ', after: ' + x.ask + '"><span class="tag b">Before</span><span class="tag a">After</span></div>' +
        '<p class="gl-foot"><span>' + x.title + '</span><a class="ais-focus" href="' + AIS.remix(x.handle) + '">Try it on this</a></p></article>';
    }).join('');
    dots.innerHTML = L.map(function (x, j) { return '<button class="ais-focus" aria-pressed="false" aria-label="Example ' + (j + 1) + ': ' + x.title + '"></button>'; }).join('');
    var cards = Array.prototype.slice.call(row.querySelectorAll('.gl-card'));
    var C = cards.map(function (card, i) {
      var c = { card: card, t: card.querySelector('.t'), text: kind === 'd' ? L[i].prompt : L[i].ask };
      if (kind === 'd') c.fr = card.querySelector('.ais-frame');
      else { c.el = card.querySelector('.ais-cmp'); c.cmp = new E.Compare(c.el, 'Slide to compare ' + L[i].title + ' before and after'); c.el.insertAdjacentHTML('beforeend', '<div class="bar"></div><div class="knob">' + AIS.icon.drag + '</div>'); c.cmp.set(100); }
      return c;
    });
    function reset(c) { c.t.textContent = ''; if (c.fr) { c.fr.classList.add('dark'); c.fr.classList.remove('busy'); } else { c.cmp.stop(); c.cmp.set(100); c.el.classList.remove('ready'); } }
    function final(c) { c.t.textContent = c.text; if (c.fr) c.fr.classList.remove('dark', 'busy'); else { c.cmp.set(50); c.el.classList.add('ready'); } }
    function play(c, T, k) {
      reset(c);
      return T.wait(250, k).then(function () { return T.type(c.t, c.text, k, 32); }).then(function () {
        if (c.fr) {
          c.fr.classList.add('busy');
          return T.wait(1100, k).then(function () { c.fr.classList.remove('dark'); return T.wait(900, k); }).then(function () { c.fr.classList.remove('busy'); });
        }
        return T.wait(350, k).then(function () { if (!T.live(k)) throw 'stop'; return c.cmp.sweep(0, 1500); })
          .then(function () { return T.wait(600, k); })
          .then(function () { if (!T.live(k)) throw 'stop'; return c.cmp.sweep(50, 800); })
          .then(function () { c.el.classList.add('ready'); });
      });
    }
    function carousel() { return getComputedStyle(row).overflowX === 'auto' && row.scrollWidth > row.clientWidth + 4; }
    var programmatic = 0, pl;
    function slideTo(i, smooth) {
      programmatic = Date.now();
      row.scrollTo({ left: cards[i].offsetLeft - parseFloat(getComputedStyle(row).paddingLeft || 0), behavior: smooth ? 'smooth' : 'auto' });
    }
    cards.forEach(function (c) { reset(C[cards.indexOf(c)]); });
    if (E.reduce) { C.forEach(final); return; }
    pl = new E.Player({
      root: act, watch: row, n: L.length, chips: dots.querySelectorAll('button'), pause: act.querySelector('.ais-pause'), hold: 2600, threshold: .5, manual: true,
      show: function () { C.forEach(final); },
      run: function (i, T, k) {
        cards.forEach(function (c, j) { c.classList.toggle('on', j === i); });
        var slide = carousel(); if (slide) slideTo(i, true);
        return T.wait(slide ? 450 : 250, k).then(function () { return play(C[i], T, k); });
      }
    });
    /* start once the row is in view (phones and computers alike) */
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !pl.started) pl.start(0); });
    }, { threshold: .4 }).observe(row);
    /* someone swiped: carry on from the card they landed on */
    var st = 0;
    row.addEventListener('scroll', function () {
      if (!carousel() || Date.now() - programmatic < 900) return;
      clearTimeout(st);
      st = setTimeout(function () {
        var x = row.scrollLeft, best = 0, bd = 1e9;
        cards.forEach(function (c, j) { var d = Math.abs(c.offsetLeft - parseFloat(getComputedStyle(row).paddingLeft || 0) - x); if (d < bd) { bd = d; best = j; } });
        if (best !== pl.i || !pl.started) pl.start(best);
      }, 160);
    }, { passive: true });
    /* dragging a before/after line stops the cards moving on */
    var userStopped = false;
    C.forEach(function (c) { if (c.cmp) c.cmp.onUser = function () { userStopped = true; if (!pl.paused) { pl.tok++; pl.setPaused(true, true); pl.waiting = true; } }; });
    /* computers: hovering over or tabbing into the cards holds the one-by-one reveal; leaving lets it carry on
       (unless a before/after line was dragged, which stops it for good) */
    function hold(on) {
      if (carousel() || !pl.started || userStopped) return;
      if (on) { if (!pl.paused) pl.setPaused(true, true); } else if (pl.paused) pl.setPaused(false);
    }
    row.addEventListener('mouseenter', function () { hold(true); });
    row.addEventListener('mouseleave', function () { hold(false); });
    row.addEventListener('focusin', function () { hold(true); });
    row.addEventListener('focusout', function (e) { if (!row.contains(e.relatedTarget)) hold(false); });
  }
  window.AIS_GAL = { html: html, create: create, where: whereHtml };
})();

/* Daybreak (A3) and Daybreak, stays dark (A4). A1's dawn, then the sky keeps lightening. In A3 it becomes full
   daylight and the words turn plum; in A4 it stops at a deep plum dusk and the words stay white. Then the two
   wall-style galleries, which move on by themselves on phones. */
(function () {
  var E = window.AISE;
  function hex(h) { return [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16); }); }
  function mix(stops, t) {
    for (var i = 1; i < stops.length; i++) if (t <= stops[i][0]) {
      var a = stops[i - 1], b = stops[i], u = (t - a[0]) / (b[0] - a[0] || 1), A = hex(a[1]), B = hex(b[1]);
      return 'rgb(' + A.map(function (v, j) { return Math.round(v + (B[j] - v) * u); }).join(',') + ')';
    }
    return stops[stops.length - 1][1];
  }
  var MODES = {
    light: {
      SKY: [[0, '#0E0A12'], [.3, '#2A1F33'], [.55, '#6E557E'], [.78, '#D9BFE3'], [1, '#F8F2FB']],
      CORE: [[0, '#0B080E'], [.3, '#21182A'], [.55, '#5F4870'], [.78, '#D0B5DB'], [1, '#F8F2FB']],
      FG: [[0, '#FFFFFF'], [.55, '#FFFFFF'], [.8, '#3B303E'], [1, '#3B303E']],
      KC: [[0, '#DDD0E6'], [.55, '#DDD0E6'], [.8, '#9A6BB0'], [1, '#9A6BB0']],
      TC: [[0, '#E3D9EA'], [.55, '#E3D9EA'], [.8, '#5A5160'], [1, '#5A5160']], lit: true
    },
    dark: {
      SKY: [[0, '#0E0A12'], [.5, '#1B1323'], [1, '#241C2A']],
      CORE: [[0, '#0B080E'], [1, '#100B14']],
      FG: [[0, '#FFFFFF'], [1, '#FFFFFF']], KC: [[0, '#DDD0E6'], [1, '#DDD0E6']], TC: [[0, '#E3D9EA'], [1, '#E3D9EA']], lit: false
    }
  };
  function galleries(root, light) {
    var g = root.querySelector('.a3-gal'); if (!g) return;
    g.innerHTML = AIS_GAL.html('d', { light: light }) + AIS_GAL.html('c', { light: light });
    g.querySelectorAll('.gl-act').forEach(AIS_GAL.create);
  }
  function boot() {
    document.querySelectorAll('.a3').forEach(function (root) {
      var M = MODES[root.getAttribute('data-mode') || 'light'];
      root.querySelectorAll('.js-spark').forEach(function (s) { s.innerHTML = AIS.icon.spark; });
      var st = root.querySelector('.aia-stick');
      E.pin(root.querySelector('.aia-intro'), function (p) {
        var day = E.inout(E.seg(p, .46, .92));
        var v = { rise: E.ease(E.seg(p, 0, .32)), glow: E.ease(E.seg(p, .03, .32)), k: E.ease(E.seg(p, .01, .1)), tt: E.ease(E.seg(p, .08, .24)),
          tg: E.ease(E.seg(p, .22, .32)), fan: E.ease(E.seg(p, .28, .46)), day: day };
        for (var k in v) st.style.setProperty('--' + k, v[k].toFixed(4));
        if (M.lit) root.classList.toggle('lit', day > .62);
        st.style.setProperty('--sbg', mix(M.SKY, day)); st.style.setProperty('--pcore', mix(M.CORE, day));
        st.style.setProperty('--fgc', mix(M.FG, day)); st.style.setProperty('--kc', mix(M.KC, day)); st.style.setProperty('--tc', mix(M.TC, day));
      }, .3);
      galleries(root, M.lit);
    });
  }
  window.AIS_A3 = { boot: boot, mix: mix, galleries: galleries };
})();

/* Daybreak, cinematic video (A5, and A6 which stays dark). Scroll plays the sunrise film frame by frame on a canvas (the way product launch
   pages do), the name arrives over the dark sky, the paintings rise from behind the film's horizon, then the day
   comes up as in A3. Phone-shaped screens use the 9:16 film, wide screens the 16:9 film. */
(function () {
  var E = window.AISE, N = 97;
  /* horizon of the last frame, in film pixels (measured from the frames) */
  var FILMS = {
    p: { w: 540, h: 960, cx: 270, top: 611, r: 4000, pre: 'vp' },
    d: { w: 1280, h: 720, cx: 667.5, top: 412.4, r: 5921, pre: 'vd' }
  };
  function pad(n) { return ('00' + n).slice(-3); }
  function boot(scope) {
    var list = scope && scope.matches && scope.matches('.a5') ? [scope] : (scope || document).querySelectorAll('.a5');
    Array.prototype.forEach.call(list, function (root) {
      if (root.hasAttribute('data-ais-done')) return; root.setAttribute('data-ais-done', '');
      var M = { SKY: [[0, '#2A2036'], [.3, '#4A3A5C'], [.55, '#7A6290'], [.78, '#D9BFE3'], [1, '#F8F2FB']],
        CORE: [[0, '#0D0B10'], [.3, '#2A2133'], [.55, '#5F4870'], [.78, '#D0B5DB'], [1, '#F8F2FB']],
        FG: [[0, '#FFFFFF'], [.55, '#FFFFFF'], [.8, '#3B303E'], [1, '#3B303E']],
        KC: [[0, '#DDD0E6'], [.55, '#DDD0E6'], [.8, '#9A6BB0'], [1, '#9A6BB0']],
        TC: [[0, '#E3D9EA'], [.55, '#E3D9EA'], [.8, '#5A5160'], [1, '#5A5160']] };
      root.querySelectorAll('.js-spark').forEach(function (s) { s.innerHTML = AIS.icon.spark; });
      var st = root.querySelector('.aia-stick'), cv = root.querySelector('.a5-vid'), ctx = cv.getContext('2d');
      var film = null, frames = [], cur = -1, want = 0, geo = null;
      function ovpx() { return parseFloat(getComputedStyle(root).getPropertyValue('--ais-ov')) || 0; }
      function pickFilm() {
        var f = st.clientWidth / (st.clientHeight - ovpx()) < 1 ? FILMS.p : FILMS.d;
        if (f === film) return; film = f; frames = []; cur = -1;
        for (var i = 1; i <= N; i++) { var im = new Image(); im.decoding = 'async'; im.src = AIS.a('assets/' + f.pre + '-' + pad(i) + '.webp'); frames.push(im); if (i === N) im.onload = function () { draw(true); }; }
        frames[0].onload = function () { draw(true); };
      }
      function layout() {
        pickFilm();
        var W = st.clientWidth, H = st.clientHeight, OV = ovpx(), H0 = H - OV, dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        var s = Math.max(W / film.w, H0 / film.h), ox = (W - film.w * s) / 2, oy = OV + (H0 - film.h * s) / 2;
        geo = { s: s, ox: ox, oy: oy, dpr: dpr, ov: OV };
        var r = film.r * s, cx = ox + film.cx * s, top = oy + film.top * s;
        st.style.setProperty('--pr', r.toFixed(1) + 'px'); st.style.setProperty('--pcx', cx.toFixed(1) + 'px'); st.style.setProperty('--pcy', (top + r).toFixed(1) + 'px');
        draw(true);
      }
      function ok(im) { return im && im.complete && im.naturalWidth; }
      function draw(force) {
        var w = Math.max(0, Math.min(N - 1, want)), i = Math.floor(w), a = w - i;
        var im = frames[i]; if (!ok(im)) { for (var j = i; j >= 0; j--) if (ok(frames[j])) { im = frames[j]; a = 0; break; } }
        if (!ok(im) || (!force && w === cur)) return;
        cur = w; var g = geo;
        ctx.setTransform(g.dpr, 0, 0, g.dpr, 0, 0); ctx.globalAlpha = 1;
        ctx.drawImage(im, g.ox, g.oy, film.w * g.s, film.h * g.s);
        /* blend towards the next frame so slow playback stays smooth */
        var nx = frames[i + 1];
        if (a > .02 && ok(nx)) { ctx.globalAlpha = a; ctx.drawImage(nx, g.ox, g.oy, film.w * g.s, film.h * g.s); ctx.globalAlpha = 1; }
      }
      /* A6/A7: the cards start a short, fixed distance under the last line of the opening (no empty band) */
      function pull() {
        var g = root.querySelector('.a3-gal'); if (!g || !root.classList.contains('dk')) return;
        var cue = root.querySelector('.aia-cue'), tag = root.querySelector('.aia-tag');
        var a = cue && getComputedStyle(cue).display !== 'none' ? cue : tag;
        var act = g.querySelector('.gl-act'), padTop = act ? parseFloat(getComputedStyle(act).paddingTop) : 0;
        var gap = window.innerWidth >= 1024 ? 76 : 54;
        root.style.setProperty('--pull', Math.max(0, st.clientHeight + padTop - (a.offsetTop + a.offsetHeight) - gap).toFixed(0) + 'px');
      }
      layout(); window.addEventListener('resize', layout);
      var dark = root.getAttribute('data-mode') === 'dark';
      if (root.getAttribute('data-play') === 'auto') { autoplay(); AIS_A3.galleries(root, false); pull(); return; }
      /* A7: no scroll scenes. The opening plays by itself, like a short film, once it is on screen; the page scrolls
         normally the whole time. It plays once and holds on the last frame (the corner pause / play again button was
         removed at the owner's request; it still works if a .a7-play button is put back). */
      function autoplay() {
        var btn = root.querySelector('.a7-play'), t = 0, last = 0, playing = false, started = false, done = false;
        function vars(t) {
          want = E.clamp((t - .3) / 8.1) * (N - 1); draw(false);
          var v = { rise: 1, glow: 1, day: 0, k: E.ease(E.seg(t, .6, 1.4)), tt: E.ease(E.seg(t, .9, 2.4)), tg: E.ease(E.seg(t, 4.2, 5.2)),
            fan: E.inout(E.seg(t, 5.2, 7.4)), dusk: E.inout(E.seg(t, 5.6, 8.2)) };
          for (var k in v) st.style.setProperty('--' + k, v[k].toFixed(4));
          root.classList.toggle('ais-named', v.tt >= 1);
        }
        function setBtn() {
          if (!btn) return;
          btn.innerHTML = done ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>' : playing ? AIS.icon.pause : AIS.icon.play;
          btn.setAttribute('aria-label', done ? 'Play the opening again' : playing ? 'Pause the opening' : 'Play the opening');
        }
        function frame(now) {
          if (!playing) return;
          t += Math.min(.25, (now - last) / 1000); last = now; vars(t);
          if (t >= 8.6) { playing = false; done = true; setBtn(); return; }
          requestAnimationFrame(frame);
        }
        function play() { if (done) { t = 0; done = false; } playing = true; last = performance.now(); setBtn(); requestAnimationFrame(frame); }
        if (btn) btn.addEventListener('click', function () { if (playing) { playing = false; setBtn(); } else play(); });
        if (E.reduce) { done = true; vars(9); setBtn(); return; }
        vars(0); setBtn();
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !started) { started = true; play(); } }); }, { threshold: .35 }).observe(st);
      }
      E.pin(root.querySelector('.aia-intro'), function (p) {
        want = Math.round(E.seg(p, 0, dark ? .56 : .48) * (N - 1)); draw(false);
        if (dark) {
          /* A6: no daylight. The film holds on the sunrise, the paintings rise, and the bottom of the frame settles into
             the section's night color so the cards below follow on without a seam. */
          var dv = { rise: 1, glow: 1, k: E.ease(E.seg(p, .03, .14)), tt: E.ease(E.seg(p, .12, .34)), tg: E.ease(E.seg(p, .46, .58)), fan: E.ease(E.seg(p, .56, .76)), day: 0, dusk: E.inout(E.seg(p, .6, .86)) };
          for (var dk in dv) st.style.setProperty('--' + dk, dv[dk].toFixed(4));
          return;
        }
        var day = E.inout(E.seg(p, .64, .93));
        var v = { rise: 1, glow: 1, k: E.ease(E.seg(p, .03, .12)), tt: E.ease(E.seg(p, .1, .28)), tg: E.ease(E.seg(p, .38, .48)), fan: E.ease(E.seg(p, .48, .63)), day: day };
        for (var k in v) st.style.setProperty('--' + k, v[k].toFixed(4));
        root.classList.toggle('lit', day > .62);
        st.style.setProperty('--sbg', AIS_A3.mix(M.SKY, day)); st.style.setProperty('--pcore', AIS_A3.mix(M.CORE, day));
        st.style.setProperty('--fgc', AIS_A3.mix(M.FG, day)); st.style.setProperty('--kc', AIS_A3.mix(M.KC, day)); st.style.setProperty('--tc', AIS_A3.mix(M.TC, day));
      }, .3);
      AIS_A3.galleries(root, !dark); pull();
    });
  }
  window.AIS_A5 = { boot: boot };
})();

/* theme: start the section only when it is about a screen away, so the film frames and pictures are not downloaded
   with the rest of the homepage. Runs again when the theme editor reloads the section. */
(function () {
  function go(sec) { if (sec.hasAttribute('data-ais-on')) return; sec.setAttribute('data-ais-on', ''); AIS_END.boot(sec); AIS_A5.boot(sec); }
  /* the custom section above ends in packaging-paper waves. Slide this section up under them (by the waves' height),
     keep that section on top, and let its waves show this section's sky instead of a flat dark band. Only when the
     section right above has those waves; otherwise nothing changes. Inline styles only, so nothing is left behind if
     this section is removed. */
  function join(sec) {
    var wrap = sec.closest('.shopify-section'), prev = wrap && wrap.previousElementSibling;
    var edge = prev && prev.querySelector('.cps-edge-bot');
    if (!edge || !edge.offsetHeight) { sec.classList.remove('ais-under'); sec.style.removeProperty('--ais-ov'); return; }
    var h = edge.getBoundingClientRect().height, box = edge.closest('.cps-sec') || edge.parentElement;
    prev.style.position = 'relative'; prev.style.zIndex = '1'; edge.style.background = 'transparent';
    /* that section's cream background also runs behind its waves; stop it where the waves start (the waves' own
       picture is cream above them), so the gaps between the waves show this section */
    box.style.background = 'linear-gradient(to bottom, var(--bg, #FBF8F4) calc(100% - ' + (h - 1).toFixed(1) + 'px), transparent calc(100% - ' + (h - 1).toFixed(1) + 'px))';
    sec.style.setProperty('--ais-ov', h.toFixed(1) + 'px'); sec.classList.add('ais-under');
  }
  function joinAll() { Array.prototype.forEach.call(document.querySelectorAll('.aia[data-ais]'), join); }
  function init(scope) {
    var list = (scope || document).querySelectorAll('.aia[data-ais]');
    if (scope && scope.matches && scope.matches('.aia[data-ais]')) list = [scope];
    Array.prototype.forEach.call(list, function (sec) {
      join(sec);
      if (!('IntersectionObserver' in window)) return go(sec);
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); go(sec); } }); }, { rootMargin: '1000px 0px' });
      io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); joinAll(); });
  var rz = 0; window.addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(joinAll); });
})();
